import React from 'react';
import { async, fromJSX, Widget, Updater } from "widgets-for-react"
import { State } from '../../../cmsPage.widget'
import { initOverviewWidget, OverviewState, overviewUrlMap, updateOverviewItems, updateOverviewItemsOptions, updateOverviewUrlMap } from './overviewWidget.state'
import { renderOverviewItems } from "./components/overviewItems.widget"
import { Pagination } from './components/pagination.layout';
import { setWindowHistory, getUrlToCurrentState } from './overviewWidget.utils';

export const overviewWidget = (overviewState: OverviewState, state: State): Widget<Updater<OverviewState>> => {
  return fromJSX(setState => {
    
    if(window.location.href != overviewUrlMap.get(overviewState.overviewItemsCacheKeyName)){
      updateOverviewUrlMap(overviewState.overviewItemsCacheKeyName, window.location.href)
      setState(s => initOverviewWidget(false, overviewState.overviewItemsCacheKeyName, overviewState.defaultPageSize, overviewState.optionalNotInUrlParameters, overviewState.hideFilters, overviewState.options))
    }

    return (
      <>
        {async(overviewState.options).run(updateOverviewItemsOptions(setState))}
        {async(overviewState.overviewItems).run(updateOverviewItems(setState))}

        {renderOverviewItems(overviewState)}
        
        {overviewState.overviewItems.kind == "loaded" ?
          <Pagination
            setPage={p => {
              setWindowHistory(state, overviewState, p, true)
              setState(s => s)
            }}
            getUrlToPage={p => {
              return getUrlToCurrentState(state, overviewState, p, true)
            }}
            pager={overviewState.overviewItems.value.pager}
          />
          : null}
      </>
    )
  })
}






